import { Loader2, AlertTriangle, Hexagon, Ban } from "lucide-react";

export const Loading = ({ label = "Loading", className = "", testid = "state-loading" }) => (
  <div data-testid={testid} className={`flex items-center gap-3 text-sm text-slate-400 py-8 justify-center ${className}`}>
    <Loader2 className="h-4 w-4 animate-spin text-lime" /> {label}
  </div>
);

export const Empty = ({ title = "Nothing here yet", hint, testid = "state-empty" }) => (
  <div data-testid={testid} className="flex flex-col items-center text-center gap-2 py-10 px-4">
    <Hexagon className="h-8 w-8 text-lime/40" />
    <p className="text-sm text-slate-300">{title}</p>
    {hint && <p className="text-xs text-slate-500 max-w-xs">{hint}</p>}
  </div>
);

export const ErrorState = ({ message, onRetry, testid = "state-error" }) => (
  <div data-testid={testid} className="flex flex-col items-center text-center gap-2 py-8 px-4">
    <AlertTriangle className="h-6 w-6 text-danger" />
    <p className="text-sm text-slate-300 max-w-sm">{message}</p>
    {onRetry && (
      <button data-testid={`${testid}-retry`} onClick={onRetry} className="text-xs text-lime hover:underline">
        Retry
      </button>
    )}
  </div>
);

export const Unavailable = ({ title, reason, testid = "state-unavailable" }) => (
  <div data-testid={testid} className="rounded-lg border border-warning/30 bg-warning/5 p-4 flex gap-3">
    <Ban className="h-4 w-4 text-warning shrink-0 mt-0.5" />
    <div>
      <p className="text-sm font-semibold text-warning">{title}</p>
      {reason && <p className="text-xs text-slate-400 mt-1 leading-relaxed">{reason}</p>}
    </div>
  </div>
);

export const Panel = ({ title, icon: Icon, right, children, className = "", testid }) => (
  <section data-testid={testid} className={`glass rounded-xl ${className}`}>
    {title && (
      <header className="flex items-center justify-between gap-3 px-5 pt-4 pb-3 border-b border-white/5">
        <h2 className="flex items-center gap-2 font-display text-xs font-bold tracking-[0.2em] uppercase text-slate-200">
          {Icon && <Icon className="h-4 w-4 text-lime" />} {title}
        </h2>
        {right}
      </header>
    )}
    {children}
  </section>
);
